import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g fill="#474747"><path d="M5.5 0C2.475 0 0 2.478 0 5.5c0 1.999 1.09 3.75 2.7 4.71l1.363-1.523A3.468 3.468 0 012 5.5C2 3.559 3.556 2 5.5 2a3.48 3.48 0 013.156 1.969L10.125 2.5A5.54 5.54 0 005.5 0zm4.906 8.969L9 10.375l3.281 3.313c.368.376 1.046.384 1.422.015.377-.368.384-1.045.016-1.422z" style={{
        lineHeight: "normal",
        InkscapeFontSpecification: "Sans",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textTransform: "none",
        marker: "none"
      }} color="#000" fontWeight={400} fontFamily="Sans" overflow="visible" /><path d="M3.002 11L12 2c1 0 2 1 2 2l-9 9H3z" fillRule="evenodd" /><path d="M13 1c1 0 2 1 2 2l1-1c0-1-.752-2-2-2z" style={{
        marker: "none"
      }} overflow="visible" /></g></svg>;
}

export default SvgComponent;